import axios from 'axios'
import { authHeader } from '../_helpers'

export default () => {
  return axios.create({
    baseURL: `https://vaworksliveapi2.azurewebsites.net/api`,
    // baseURL: `https://localhost:63280/api`,
    // For development
    headers: authHeader()
  })
}



// WEBPACK FOOTER //
// ./src/api/VaWorksApi.js